// Matches the banner's `h-8` (32px) + border-b (1px). Keep in sync with
// OfflineBanner / BackgroundSyncBanner / SlowConnectionBanner / PrefetchProgressBar.
export const TOP_STATUS_BANNER_HEIGHT_PX = 33

type BannerOffsetParams = {
  bannerIndex: number
}

type ContentOffsetParams = {
  hasStatusBanner: boolean
  hasPrefetchBanner: boolean
}

export function getTopBannerOffsetPx({ bannerIndex }: BannerOffsetParams): number {
  return Math.max(0, bannerIndex) * TOP_STATUS_BANNER_HEIGHT_PX
}

// Background sync banner is intentionally excluded — it overlays content
// instead of reserving space, so transient fetches don't trigger a layout
// shift on every query refresh.
export function getTopBannerContentOffsetPx({
  hasStatusBanner,
  hasPrefetchBanner,
}: ContentOffsetParams): number {
  const bannerCount = Number(hasStatusBanner) + Number(hasPrefetchBanner)
  return bannerCount * TOP_STATUS_BANNER_HEIGHT_PX
}
